import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { ScadenzarioFormComponent } from '../../../form/scadenzario/scadenzario-form.component';
import { Scadenza } from '../../../models/scadenza';
import { SezioneScadenze } from '../../../models/sezioni/sezione-scadenze';

@Component({
    selector: 'div [scadenzario-form-add]',
  templateUrl: '../../../form/scadenzario/scadenzario-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ScadenzaAddConcreteFormComponent extends ScadenzarioFormComponent implements OnInit {

  idSezione: string;
  urlAddScadenza: string;

  @Output()
  onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();

  @Output()
  onScadenzaInseritaForAuto: EventEmitter<Scadenza> = new EventEmitter<Scadenza>();

  @Output()
  lastID: EventEmitter<string> = new EventEmitter<string>();


  constructor(@Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService, private viewManager: ViewManagerService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Adempimento');
    this.isInserimento(true);
  }

  getScadenza() {
    return new Scadenza();
  }

  getRequest(request: Scadenza) {
    this.operationService.addScadenza(this.urlAddScadenza, request, this.idSezione, this.idFascicolo).subscribe(response => this.sezioneScadenzeUpdated(response, request));
  }

  sezioneScadenzeUpdated(response, scadenzaIns) {
    if (response.returnCode === 'OK') {
      this.viewManager._prossimiAdempimenti.next({param: null, timeOut: true});
      this.onReturn.emit(response.sezione);
      this.lastID.emit(response.lastID);
      this.onScadenzaInseritaForAuto.emit(scadenzaIns);
    }
  }

  inizializza(url: string, idSezione: string, idFascicolo: string, fascicoloGeneric: string) {
    this.urlAddScadenza = url;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.populateSelect(fascicoloGeneric);
    this.createForm();
  }
}
